import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Textarea,
  useDisclosure,
  addToast,
} from "@heroui/react";
import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api-client";
import { t } from "@lingui/core/macro";

interface CustomerAppointmentCommentProps {
  customerAppointmentId: number;
  initialComment?: string;
}

export default function CustomerAppointmentComment({
  customerAppointmentId,
  initialComment = "",
}: CustomerAppointmentCommentProps) {
  const { isOpen, onOpenChange } = useDisclosure();
  const [comment, setComment] = useState(initialComment);

  const { mutateAsync: updateCustomerAppointment } =
    api.customerAppointment.useUpdateCustomerAppointment();

  const handleSave = async () => {
    try {
      await updateCustomerAppointment({
        customerAppointmentId,
        body: {
          comment,
        },
      });

      addToast({
        title: t`Komentar shranjen`,
        description: t`Komentar je bil uspešno posodobljen`,
        color: "success",
      });

      onOpenChange();
    } catch (error) {
      addToast({
        title: t`Napaka`,
        description: t`Prišlo je do napake pri shranjevanju komentarja`,
        color: "danger",
      });
    }
  };

  return (
    <>
      <Button
        isIconOnly
        size="sm"
        variant="light"
        onPress={() => onOpenChange()}
      >
        <MessageCircle className="h-4 w-4" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          <ModalHeader>{t`Komentar termina`}</ModalHeader>
          <ModalBody>
            <Textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={t`Vnesite komentar...`}
              rows={4}
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="light" onPress={() => onOpenChange()}>
              {t`Prekliči`}
            </Button>
            <Button color="primary" onPress={handleSave}>
              {t`Shrani`}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
